import { map } from "rxjs";
import { UserToken } from "../../../model";
import apiService from "../../ApiService";
export interface StcSignupOpts {
  msisdn: string;
  plan: string;
  otp: string;
  authorizationId: string;
}
export const stcSignup = (opts: StcSignupOpts) => {
  return apiService
    .post<UserToken>({
      path: `v1/store/stc/signup`,
      body: { ...opts },
    })
    .pipe(
      map((token) => {
        apiService.familyToken = token.familyToken;
        apiService.userToken = token.userToken;
        return token;
      }),
    );
};
